export default __webpack_public_path__ + "static/media/nutrionist@3x.38f62a9b.png";